<div class="layout-container" [class.is-mobile]="mobileQuery.matches">
  <mat-toolbar color="primary" class="nav-layout-toolbar">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <img [src]="'assets/images/folio-logo-white.png'" (click)="loadDefaultPage()" height="48" [ngStyle]="{'cursor': 'pointer'}" />

    <!-- <h1>Folio</h1> -->
    <!-- </a> -->
    <!-- Dummy Spacer -->
    <span class="nav-layout-spacer"></span>
    <!-- help icon -->
    <button *ngIf="false" mat-icon-button [matMenuTriggerFor]="settingsMenu">
      <mat-icon>help_outline</mat-icon>
    </button>
    <mat-menu #settingsMenu="matMenu" [overlapTrigger]="false" style="text-align: center;">
      <div style="padding-left: 12px;padding-right: 12px;">
        <div class="help-title"><span style="font-weight:bold;font-size: 19px">contact@focalcxm.com</span></div>
      </div>
    </mat-menu>
    <!-- Alerts icon -->
    <!-- <mat-icon *ngIf="false" matBadge="{{alertsBadgeValue}}" matBadgeColor="accent" matBadgeSize="medium">
      notifications_none</mat-icon> -->
    <!-- Settings -->
    <div [matMenuTriggerFor]="sideMenu" style="cursor: pointer;">
      <button mat-icon-button class="nav-layout-icon">
        <mat-icon color="accent">perm_identity</mat-icon>
      </button>
      <span style="font-size: 16px; vertical-align: middle;">{{username}}</span>
      <mat-icon style="color: white !important; vertical-align: middle !important;">arrow_drop_down</mat-icon>

    </div>
    <mat-menu #sideMenu="matMenu" [overlapTrigger]="false">
      <!-- <button mat-menu-item>
        <mat-icon>account_circle</mat-icon>
        <span>{{username}}</span>
      </button> -->
      <!-- Hidden for now
      <button mat-menu-item (click)="goToBatonDashboard()">
        <mat-icon>dashboard</mat-icon>
        <span>Dashboard</span>
      </button>
      -->
      <button mat-menu-item (click)="goToBatonConfig()">
        <mat-icon>settings</mat-icon>
        <span>Configurations</span>
      </button>
      <button mat-menu-item (click)="logoutUser()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
    <!-- Settings Menu END -->
  </mat-toolbar>

  <mat-sidenav-container [hasBackdrop]=true class="nav-layout-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav [style.min-width]="'7rem'" [style.width]="'15rem'" #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <mat-nav-list *ngFor="let nav of fillerNav">
        <a mat-list-item [routerLink]="nav.path" routerLinkActive="active-link" (click)='snav.toggle()'>
          <mat-icon>{{nav.icon}}</mat-icon>&nbsp; {{nav.name}}
        </a>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content [style.padding]="paddingValue" style="background: #eee;">
      <router-outlet></router-outlet>
      <!-- <app-users-list></app-users-list> -->
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>